class InfiniteScrollPagination extends HTMLElement {
  constructor() {
    super();
    const watcher = this.querySelector('.pagination-wrapper.more');
    const moreAnchor = this.querySelector('.pagination-wrapper.more > a');
    if (moreAnchor) moreAnchor.style.pointerEvents = 'none';

    let observerOptions = {
      root: null,
      rootMargin: '0px 0px 200% 0px',
      threshold: 0,
    };

    let observer = new IntersectionObserver(async (entries, observer) => {
      for (let entry of entries) {
        if (entry.isIntersecting) {
          await loadMoreContent();
        }
      }
    }, observerOptions);

    if (watcher) {
      observer.observe(watcher);
    }

    async function loadMoreContent() {
      try {
        if (!moreAnchor) return;

        const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
        const scrollPosition = scrollTop + clientHeight;
        const scrollOffset = 6000;

        if (scrollPosition >= scrollHeight - scrollOffset && moreAnchor.innerHTML != watcher.dataset.loading) {
          moreAnchor.innerHTML = watcher.dataset.loading;

          const newURL = new URL(moreAnchor.href);
          const page = newURL.searchParams.get('page') || 1;
          let currentURL = new URL(moreAnchor.baseURI).href;

          if (currentURL.includes('?')) currentURL += `&page=${page}`;
          else currentURL += `?page=${page}`;

          const response = await fetch(currentURL);
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const source = doc.body.querySelector('ul#product-grid')?.innerHTML;
          const productGrid = document.querySelector('ul#product-grid');

          if (source) productGrid.insertAdjacentHTML('beforeend', source);
          const nextPage = parseInt(page) + 1;

          if (nextPage <= parseInt(moreAnchor.id)) {
            newURL.searchParams.set('page', nextPage);
            moreAnchor.href = newURL.href;

            moreAnchor.innerHTML = watcher.dataset.noticelabel;
          } else {
            moreAnchor.remove();
          }
        }
      } catch (error) {
        console.error(error);
        moreAnchor.style.pointerEvents = 'auto';
      }
    }

    loadMoreContent();
  }
}

customElements.define('infinite-scroll-pagination', InfiniteScrollPagination);
